module.exports = __webpack_public_path__ + "static/media/fast-reverse.8462eeda.svg";